/**
 * @param   {[]Function} composing
 * @returns {Function}
 */
export default function composeEventHandlers(...composing) {
  return (event, ...args) => {
    let lastReturnValue;

    composing.some(fn => {
      if (fn && typeof fn === "function") {
        lastReturnValue = fn(event, ...args);
      }

      return event.defaultPrevented;
    });

    return lastReturnValue;
  };
}
